import React from 'react';
import Loader from 'components/Loader';
import Style from './Loading.module.scss';

const Loading = () => (
  <div className={Style.container}>
    <Loader />
  </div>
);

export default Loading;
